import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
import jsPDF from "jspdf";
import "jspdf-autotable";
var dateFormat = require("dateformat");
var btoa = require("Base64").btoa;

function* fetchPayments(params) {
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";

  let filter = (params.params && params.params.filter) || "";
  let secfilter = (params.params && params.params.secfilter) || "";
  let thirdfilter = (params.params && params.params.thirdfilter) || "";
  let dateFilter = (params.params && params.params.dateFilter) || "";

  let filterParam = "";
  if (filter) {
    filterParam = `&type=${filter}`;
  }

  let secfilterParam = "";
  if (secfilter) {
    secfilterParam = `&status=${secfilter}`;
  }

  let thirdfilterParam = "";
  if (thirdfilter) {
    thirdfilterParam = `&paymentType=${thirdfilter}`;
  }

  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.orgId;
  let recieverid = user.orgId;
  let url = "";
  let recieverParam = "";

  if (
    user.role === "shipper-enterprise" ||
    user.role === "shipper-individual" ||
    user.role === "shprAccount" ||
    user.role === "shprSupport" ||
    user.role === "warehouse"
  ) {
    url = `&orgId=${id}`;
  }

  if (
    user.role === "runner" ||
    user.role === "runnerTrip" ||
    user.role === "runnerSupport" ||
    user.role === "runnerAccount"
  ) {
    recieverParam = `&receiverOrgId=${user.orgId}`;
    url = `&receiverOrgId=${user.orgId}`;
  }

  if (user.role === "warehouse") {
    recieverParam = `&receiverOrgId=${user.orgId}`;
    url = `&receiverOrgId=${user.orgId}`;
  }

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/payment?limit=10&ser=${search}&page=${page}${url}${filterParam}${secfilterParam}${thirdfilterParam}${dateFilter}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_PAYMENTS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_PAYMENTS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchPaymentMode() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/paymentMode`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      let paymentMode = resJSON.rows.map((data) => {
        let paymentModes = {
          value: data.id,
          name: data.name,
        };
        return paymentModes;
      });

      yield put({
        type: actionTypes.FETCH_PAYMENTMODE_SUCCESS_ACTION,
        payload: resJSON,
        paymentMode: paymentMode,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_PAYMENTMODE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* paymentsMapActionWatcher() {
  yield takeEvery(actionTypes.FETCH_PAYMENTS_ACTION, fetchPayments);
  yield takeEvery(actionTypes.FETCH_PAYMENTMODE_ACTION, fetchPaymentMode);
}
